module.exports = __webpack_public_path__ + "img/search.109bdbc2.svg";